import React, { useState, useEffect } from "react";
import { resetPassword } from "../firebase";
import { toast } from "react-toastify";

const modalStyle = {
  overlay: {
    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1000,
    display: "flex", justifyContent: "center", alignItems: "center"
  },
  modal: {
    background: "#fff", padding: "1.5rem", borderRadius: "8px",
    width: "90%", maxWidth: "400px", boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
    transition: "opacity 0.4s ease"
  }
};

const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const ForgotPasswordModal = ({ open, onClose, initialEmail = "" }) => {
  const [email, setEmail] = useState(initialEmail);
  const [submitted, setSubmitted] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    setEmail(initialEmail || "");
  }, [initialEmail]);
    
  useEffect(() => {
    let timer;
    if (cooldown > 0) {
      timer = setTimeout(() => setCooldown((c) => c - 1), 4000);
    }
    return () => clearTimeout(timer);
  }, [cooldown]);

  const handleReset = async () => {
    try {
      await resetPassword(email);
      toast.success("Password reset email sent.");
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
        onClose();
      }, 3000);
      setCooldown(30);
    } catch (err) {
      toast.error("Failed to send reset email. Check the address.");
      console.error(err);
    }
  };

  if (!open) return null;

  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        {!submitted ? (
          <>
            <h3>🔑 Reset Your Password</h3>
            <p>Please enter your email. We’ll send a reset link if it's valid.</p>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              style={{ width: "100%", marginBottom: "1rem" }}
            />
            <div style={{ textAlign: "right" }}>
              <button onClick={onClose} style={{ marginRight: "1rem" }}>Cancel</button>
              <button
                onClick={handleReset}
                disabled={!isValidEmail(email) || cooldown > 0}
              >
                {cooldown > 0 ? `Wait ${cooldown}s` : "Reset My Password"}
              </button>
            </div>
          </>
        ) : (
          <div style={{ textAlign: "center" }}>
            <h2 style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>Email Sent!</h2>
            <p>Check your inbox for a link to reset your password.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
